<!-- eslint-disable vue/require-v-for-key -->
<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import Multiselect from 'vue-multiselect'
import { Helper, debounce } from '@/mixin/helper'
import { required } from 'vuelidate/lib/validators'

import { GET_COMPANYS } from '@/services/api/master/companies'
import { mapGetters } from 'vuex'
import { getToolsClient } from '@/services/tools'
import McButton from '@/components/McButton'

import Confirmation from '@/components/widgets/modals/Confirmation'

const toolsAxios = getToolsClient()
/**
 * Starter component
 */
export default {
  page: {
    title: 'Registrasi RFID',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
    McButton,
    Confirmation,
  },
  apollo: {
    companies: {
      query: GET_COMPANYS,
    },
  },
  mixins: [Helper],
  data() {
    return {
      rfidFields: [
        {
          key: 'columnCheck',
          thClass: 'mc-table--30',
          sortable: false,
        },
        {
          key: 'rfid',
          label: 'RFID',
          sortable: true,
        },
        {
          key: 'company_name',
          label: this.$t('rfid.table.company'),
          sortable: true,
        },
        {
          key: 'domain_name',
          label: this.$t('rfid.table.domain'),
          sortable: true,
        },
        {
          key: 'edit',
          label: this.$t('domain.table.edit'),
          class: 'text-center',
          sortable: false,
        },
      ],
      filterApi: {
        deviceTypes: null,
        status: null,
        orderBy: [JSON.stringify({ rfid: 'asc' })],
        devicetype: {
          devicetype: [],
        },
      },
      selected: {
        rfid: [],
      },
      selectedModel: {
        rfid: {},
      },
      allSelected: {
        rfid: {},
      },
      indeterminate: {
        rfid: true,
      },
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      totalPages: 0,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: 'rfid',
      sortDesc: false,
      isEdit: false,
      responseModal: {
        title: 'Registrasi RFID Berhasil',
        rfid: null,
        vehicleId: null,
        status: null,
      },
      set: {
        rfid: '',
        companies: null,
      },
      form: {
        rfid: null,
      },
      formOld: {
        rfid: null,
      },
      show_model: null,
      show: [
        { key: 'rfid', label: 'RFID' },
        { key: 'company_name', label: 'Company Name' },
        { key: 'domain_name', label: 'Domain Name' },
      ],
      isAddFavorit: false,
      addFavorit: null,
      showModal: false,
      titleModal: 'Registrasi RFID',
      deviceTypes: {
        deviceType: [],
      },
      companies: {
        companies: [],
      },

      formStatus: 'create',
      status: '',
      listDeleted: [],
      filteredItems: [],
      vehicleTypes: [],
      isLoading: false,
      showDeviceType: false,
      vehicleYear: null,
      debounceTimer: null,
      accordionVisible: false,

      rfidList: [],
      isSubmitting: false,
      isDeleting: false,
      modalConfirm: false,
    }
  },
  validations: {
    form: {
      rfid: { required },
    },
    set: {
      companies: { required },
    },
  },
  computed: {
    /**
     * Total no. of records
     */

    title() {
      return 'Registrasi RFID'
    },
    ...mapGetters({
      hasAccessAll: 'identity/hasAccessAll',
    }),
  },
  async created() {
    this.$v.set.$touch()
    await this.getRfid()
  },
  methods: {
    async getRfid() {
      this.isLoading = true
      const params = {
        page: this.currentPage,
        size: this.perPage,
        q: this.filter,
      }

      if (this.sortBy == '') {
        this.sortBy = 'rfid'
        this.sortDesc = true
      }

      let sortDirection = this.sortDesc ? 'desc' : 'asc'
      params.sorts = `${this.sortBy}:${sortDirection}`

      const res = await toolsAxios.get('/rfid', { params }).catch((error) => {
        this.handleError(error)
      })
      if (!res) return

      this.filteredItems = res.data.data
      this.rfidList = res.data.data
      this.totalRows = res.data.total_count
      this.totalPages = res.data.total_pages
      this.isLoading = false
    },

    /**
     * Search the table data with search input
     */

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.filteredItems = filteredItems
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

    addRfid() {
      this.isEdit = false
      this.form = {
        companyId: 1,
        rfid: '',
      }

      this.formStatus = 'create'
      this.$bvModal.show('modal-create')
    },
    handleInput(value, data) {
      this.editableDataItems[data.index][data.field.key] = value
    },
    nextSetup(item) {
      localStorage.setItem('device', JSON.stringify(item))
      this.$router.push({
        name: 'Setting Device',
      })
    },
    toggleAll(checked, param) {
      if (checked) {
        this.allSelected.rfid[this.currentPage] = true
        for (let i = 0; i < this.rfidList.length; i++) {
          if (!this.selectedModel[param][this.rfidList[i].rfid]) {
            this.selected[param].push(this.rfidList[i])
          }
          this.selectedModel[param][this.rfidList[i].rfid] = true
        }
      } else {
        for (let i = 0; i < this.rfidList.length; i++) {
          if (this.selectedModel[param][this.rfidList[i].rfid]) {
            this.selectedModel[param][this.rfidList[i].rfid] = false

            var selectedIdx = this.selected[param].findIndex((item) => {
              return item.rfid === this.rfidList[i].rfid
            })

            if (selectedIdx !== -1) {
              this.selected[param].splice(selectedIdx, 1)
            }
          }
        }
        this.allSelected.rfid[this.currentPage] = false
      }
    },
    checkTable(event, data, param) {
      if (event) {
        this.selected[param].push(data.item)
      } else {
        var selectedIdx = this.selected[param].findIndex((item) => {
          return item.rfid === data.item.rfid
        })

        if (selectedIdx !== -1) {
          this.selected[param].splice(selectedIdx, 1)
        }
      }
    },

    async setTo() {
      this.$bvModal.show('device-setup')
    },

    async registerToCompany() {
      this.isSubmitting = true
      /* validation before hit api */
      this.$v.set.$touch()
      if (this.$v.set.$error) {
        return
      }

      let input = {
        company_id: this.set.companies.id,
        rfids: this.getSelectedRfids(),
      }

      await toolsAxios
        .patch('/rfid/bulk-assign-to-company', input)
        .then(() => {
          this.$toast.success(`RFID Berhasil diassign`)
          this.$bvModal.hide('device-setup')
        })
        .catch((err) => {
          this.handleError(err)
        })
      this.isSubmitting = false
      this.set.companies = null
      this.getRfid()
    },
    beforeEdit(item) {
      this.showDeviceType = false
      this.isEdit = true
      this.formStatus = 'update'
      this.$bvModal.show('modal-create')
      this.form = {
        rfid: item.rfid,
      }
      this.formOld = {
        rfid: item.rfid,
      }
    },

    clearDelete() {
      this.allSelected.rfid = {}
      this.selectedModel.rfid = {}
      this.selected.rfid = []
    },
    resetModal() {
      this.form = {
        rfid: null,
      }

      this.formStatus = 'create'
      this.accordionVisible = false
    },
    handleOk(bvModalEvent) {
      // Prevent modal from closing
      bvModalEvent.preventDefault()
      // Trigger submit handler
      this.handleSubmit()
    },
    async submitRfid(bvModalEvent) {
      this.isSubmitting = true
      // Prevent modal from closing
      bvModalEvent.preventDefault()
      this.$v.form.$touch()

      if (this.$v.form.$error) {
        this.isSubmitting = false
        return
      }
      // Trigger submit handler
      if (this.isEdit) {
        await this.updateRfid()
      } else {
        await this.prosesSubmit()
      }

      this.isSubmitting = false
      this.getRfid()
    },
    async updateRfid() {
      let oldData = {
        rfid: this.formOld.rfid,
      }
      let input = {
        rfid: this.form.rfid,
      }
      const res = await toolsAxios.patch(`/rfid/${oldData.rfid}`, input).catch((error) => {
        this.handleError(error)
      })
      if (!res) return
      this.formOld.rfid = res.data.rfid
      this.form.rfid = res.data.rfid

      this.$toast.success('Success update RFID')
      this.$bvModal.hide('modal-create')
    },
    responModal(data) {
      this.getRfid()
      this.$toast.success(`RFID "` + data.rfid + `" Berhasil di daftarkan `)
      this.$root.$emit('bv::toggle::collapse', 'accordion-3')
      setTimeout(() => {
        if (!this.accordionVisible) {
          this.$root.$emit('bv::toggle::collapse', 'accordion-3')
        }
      }, 500)

      this.responseModal.vehicleId = data.vehicle_id
      this.responseModal.rfid = data.rfid
      this.responseModal.status = 'Register Success'
    },

    responModalAfterUpdate(data) {
      this.getRfid()
      this.$toast.success(`RFID "` + data.rfid + `" Berhasil di daftarkan `)
      this.$root.$emit('bv::toggle::collapse', 'accordion-3')
      setTimeout(() => {
        if (!this.accordionVisible) {
          this.$root.$emit('bv::toggle::collapse', 'accordion-3')
        }
      }, 500)

      this.responseModal.vehicleId = data.vehicle_id
      this.responseModal.rfid = data.rfid
      this.responseModal.status = 'Register Success'
    },

    async prosesSubmit() {
      let input = {
        rfid: this.form.rfid,
      }

      toolsAxios
        .post('/rfid', input)
        .then((responAxio) => {
          this.responModal(responAxio.data)
        })
        .catch((err) => {
          this.handleError(err)
        })
    },

    handleError(error) {
      if (error.response) {
        const errorStatus = error.response.status
        const errorData = error.response.data

        if (errorData.errors) {
          Object.values(errorData.errors).forEach((value) => {
            this.$toast.error(value)
          })
          return
        }

        if (errorStatus === 400 && errorData.details) {
          errorData.details.forEach((element) => {
            this.$toast.error(`${errorData.error}: ${element.field} ${element.message}`)
          })
        } else if (errorStatus === 409 && errorData.details) {
          errorData.details.forEach((element) => {
            if (
              element.message == 'rfid already exists' ||
              element.message == 'rfid already exist'
            ) {
              this.$toast.error('RFID already exist')
            }
          })
        } else if (errorStatus === 401) {
          this.$toast.error(errorData.error)
          localStorage.removeItem('token')
          localStorage.removeItem('tokenAccess')
          this.$router.push({ name: 'Login' })
        } else if (errorStatus === 403) {
          this.$toast.error(errorData.error)
        } else {
          this.$toast.error(errorData.error)
        }
      } else if (error.request) {
        this.$toast.error(error.response.statusText)
      } else {
        this.$toast.error(error.message)
      }
    },

    handleSubmit() {
      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide('modal-create')
        this.resetModal()
      })
    },
    changeStatus(status) {
      this.status = status
      if (this.selected.rfid.length > 0) {
        this.showModal = true
      } else {
        this.$toast.error(`Minimal memilih satu atau lebih dari data di bawah.`)
      }
    },
    customLabel(item) {
      return `${item.name} (${item.domainName})`
    },
    customLabelDevice(item) {
      if (item.deviceName) return `${item.deviceName}`
    },
    showDeviceTypes() {
      this.showDeviceType = true
      const interval = setInterval(() => {
        this.$refs.deviceTypeRef.isOpen = true
        if (this.$refs.deviceTypeRef) clearInterval(interval)
      }, 100)
    },
    changePage(newPage) {
      this.currentPage = newPage
      this.getRfid()
    },
    resetFilter(e) {
      this.currentPage = 1
      this.perPage = e
      this.getRfid()
    },
    searchData: debounce(function () {
      this.getRfid()
    }, 600),

    allowAlphanumeric(event) {
      const key = event.key
      const allowedKeys = [
        'Backspace',
        'Delete',
        'Tab',
        'Enter',
        'ArrowLeft',
        'ArrowRight',
        'ArrowUp',
        'ArrowDown',
      ]

      // Regular expression for alphanumeric characters
      const isAlphanumeric = /^[a-zA-Z0-9]$/

      if (!isAlphanumeric.test(key) && !allowedKeys.includes(key)) {
        event.preventDefault()
      }
    },

    sortingChanged(ctx) {
      if (ctx.sortBy == '') {
        return
      }

      this.sortDesc = ctx.sortDesc
      this.sortBy = ctx.sortBy

      this.getRfid()
    },

    async deleteRfid(rfid) {
      try {
        const res = await toolsAxios.delete(`/rfid/${rfid}`)
        return res
      } catch (error) {
        this.handleError(error)
      }
    },
    getSelectedRfids() {
      return this.selected.rfid.map((item) => item.rfid)
    },
    confirmDelete() {
      this.modalConfirm = true
    },
    async toDelete() {
      this.isDeleting = true
      const rfids = this.getSelectedRfids()

      let promises = []
      for (const element of rfids) {
        const res = await this.deleteRfid(element)
        if (!res) continue
        promises.push()
      }

      Promise.all(promises).then(() => {
        this.$toast.success(`Data berhasil dihapus`)
      })

      await this.getRfid()
      this.clearDelete()

      this.isDeleting = false
    },
  },
}
</script>
<style>
.formulate-input ul.formulate-input-errors {
  font-style: normal;
  font-size: 80%;
}
</style>
<template>
  <Layout>
    <PageHeader :title="title" />
    <p class="mb-4">Proses Alokasi RFID ke Customer</p>
    <div class="clearfix mc-btn-group__list">
      <div class="float-end">
        <b-button
          @click="$router.push({ name: 'QC Device' })"
          variant="outline-primary"
          menu-class="dropdown-menu-end"
          class="ms-3"
        >
          <i class="bx bx-arrow-back"></i> {{ $t('global.back') }}
        </b-button>
      </div>
    </div>

    <div
      class="row mb-3"
      v-if="this.getAccessFunc('addNewRFID') || hasAccessAll('rfid:read')"
    >
      <div class="col-md-6"></div>

      <div class="col-md-6 d-flex justify-content-end gap-2">
        <b-button
          id="tooltip-set-to"
          v-if="selected.rfid.length > 0 && hasAccessAll(['rfid:update', 'rfid:read'])"
          variant="me-3 btn-outline-primary"
          @click="setTo()"
          ><i class="mc-fa icon-outline_Pin-History"></i> Set to
        </b-button>
        <McButton
          v-if="$store.state.config.importDevice && hasAccessAll(['rfid:create'])"
          variant="secondary"
          :text="$t('global.upload')"
          icon="icon-outline_upload"
          @click="$router.push({ name: 'RFID Import' })"
        />
        <div
          class="mc-table-filter"
          v-if="hasAccessAll(['rfid:create'])"
        >
          <a class="popup-form btn btn-primary" href="javascript: void(0);" @click="addRfid">
            <i class="bx bx-plus"></i> {{ $t('global.addField') }}
          </a>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="clearfix">
              <div class="float-start">
                <h6 v-if="selected.rfid.length" class="mc-row-check">
                  <span class="badge btn-success">{{ selected.rfid.length }}</span>
                  Baris terpilih.
                  <a class="color-primary" @click="clearDelete">Bersihkan semua</a>
                </h6>
              </div>

              <!-- Search -->
              <div class="float-end">
                <div class="mc-table-view">
                  <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end d-flex align-items-center"
                  >
                    <div class="text-end mb-2">
                      <b-button
                        v-if="selected.rfid.length > 0 && hasAccessAll(['rfid:delete'])"
                        :disabled="isDeleting"
                        @click="confirmDelete"
                        variant="outline-danger"
                        class="mx-2"
                      >
                        <i class="bx bx-trash-alt"></i> {{ $t('global.delete') }}
                      </b-button>
                    </div>
                    <label class="d-inline-flex align-items-center mc-table-view__search ms-2">
                      <i class="mc-fa fas fa-search"></i>
                      <b-form-input
                        v-model="filter"
                        type="search"
                        :placeholder="$t('global.search') + '...'"
                        class="ms-2 form-control"
                        @input="searchData"
                      ></b-form-input>
                    </label>
                  </div>
                </div>
              </div>
              <!-- End search -->
            </div>

            <div class="table-responsive my-3 border border-1">
              <b-table
                class="datatables"
                :items="rfidList"
                :fields="rfidFields"
                show-empty
                :empty-text="$t('global.emptyTable')"
                :empty-filtered-text="$t('global.emptyFilteredTable')"
                :per-page="perPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
                :busy="isLoading"
                @hidden="resetModal"
                @sort-changed="sortingChanged"
                no-local-sorting
              >
                <template #head(columnCheck)>
                  <div class="form-check" @click.stop>
                    <b-form-checkbox
                      @change="toggleAll($event, 'rfid')"
                      v-model="allSelected.rfid[currentPage]"
                      :indeterminate="indeterminate.rfid"
                      :value="true"
                      :unchecked-value="false"
                    ></b-form-checkbox>
                  </div>
                </template>

                <template #cell(columnCheck)="data">
                  <div class="form-check">
                    <b-form-checkbox
                      @change="checkTable($event, data, 'rfid')"
                      v-model="selectedModel.rfid[data.item.rfid]"
                      :value="true"
                      :unchecked-value="false"
                    ></b-form-checkbox>
                  </div>
                </template>

                <template #head(edit)>
                  <div class="table-header" @click.stop>
                    {{ $t('domain.table.edit') }}
                  </div>
                </template>

                <template #table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                  </div>
                </template>

                <template #cell(edit)="data">
                  <span
                    v-if="hasAccessAll(['rfid:update'])"
                    id="tool-edit"
                    class="icon-fill_edit"
                    v-b-tooltip.hover.top
                    title="Edit Rfid"
                    @click="beforeEdit(data.item)"
                  ></span>
                </template>
              </b-table>
            </div>

            <div class="row mt-10">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    <span>Menampilkan</span>
                    <span>
                      <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                        @change="resetFilter"
                      />
                    </span>
                    <span>entri.&nbsp;&nbsp;</span>
                    <span
                      >Menampilkan&nbsp;
                      <strong>
                        {{ filteredItems.length > 0 ? (currentPage - 1) * perPage + 1 : 0 }}
                      </strong>
                      &nbsp;sampai&nbsp;
                      <strong>
                        {{
                          currentPage != totalPages
                            ? currentPage * perPage
                            : (currentPage - 1) * perPage + filteredItems.length
                        }}
                      </strong>
                      &nbsp;dari&nbsp;
                      <strong>{{ totalRows }}</strong>
                      &nbsp;entri.
                    </span>
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="totalRows"
                      :per-page="perPage"
                      @change="changePage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Create -->
    <b-modal
      id="device-setup"
      ref="device-setup"
      size="lg"
      title="Set RFID"
      @hidden="resetModal"
      centered
    >
      <FormulateForm v-model="set" @submit="registerToCompany">
        <div class="mb-2">
          <label class="required">{{ $t('setting.modal.selectCompany') }}</label>
          <multiselect
            v-model="set.companies"
            :options="companies.companies"
            placeholder="Pilih Company"
            :custom-label="customLabel"
            :class="{
              'is-invalid': $v.set.companies.$error,
            }"
          ></multiselect>
          <div v-if="$v.set.companies.$error" class="invalid-feedback mt-0">
            <span v-if="!$v.set.companies.required">
              {{ $t('setting.modal.selectCompany') }} Wajib Terisi
            </span>
          </div>
        </div>
      </FormulateForm>
      <template #modal-footer="{ cancel }">
        <b-row class="mc-modal__filter-footer">
          <b-col sm="12" md="8" class="mc-modal__filter-footer-fav"> </b-col>

          <b-col sm="12" md="4" class="mc-modal__filter-footer-btn">
            <b-button variant="outline-primary" @click="cancel" class="me-3"> Batal </b-button>
            <b-button
              type="submit"
              variant="primary"
              :disabled="isSubmitting"
              @click="registerToCompany"
            >
              Simpan
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>

    <b-modal
      class="mc-modal"
      id="modal-create"
      :title="isEdit ? 'Perubahan Data RFID' : 'Registrasi RFID'"
      size="lg"
      centered
      scrollable
      @hidden="resetModal"
      @ok="handleOk"
    >
      <form ref="form" class="mc-form" @submit.stop.prevent="handleSubmit">
        <b-row>
          <!-- rfid ID -->
          <b-col md="12">
            <div class="mb-3 mc-input-info">
              <label class="mt-3 required">RFID</label>
              <b-form-input
                placeholder="Masukkan RFID yang akan didaftarkan"
                v-model="form.rfid"
                type="text"
                :class="{
                  'is-invalid': $v.form.rfid.$error,
                }"
                trim
                @keydown="allowAlphanumeric"
              >
              </b-form-input>
              <div v-if="$v.form.rfid.$error" class="invalid-feedback">
                <span v-if="!$v.form.rfid.required"> RFID Wajib Terisi </span>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-button variant="primary" v-if="!isEdit" @click="submitRfid" :disabled="isSubmitting">
          Daftarkan RFID
        </b-button>
        <b-button variant="primary" v-if="isEdit" @click="submitRfid" :disabled="isSubmitting">
          {{ $t('global.saveChanges') }}
        </b-button>
        <b-row class="modal-body"><b-col md="12"></b-col></b-row>
        <b-collapse
          id="accordion-3"
          v-model="accordionVisible"
          accordion="my-accordion"
          role="tabpanel"
        >
          <b-card no-body>
            <template #header>
              <h4 class="mb-0">{{ responseModal.title }}</h4>
            </template>
            <b-list-group flush>
              <b-list-group-item>RFID : {{ responseModal.rfid }}</b-list-group-item>
              <b-list-group-item style="color: #07a76d; font-weight: bold"
                >Status : {{ responseModal.status }}</b-list-group-item
              >
            </b-list-group>
          </b-card>
        </b-collapse>
      </form>

      <template #modal-footer="{ cancel }">
        <b-row class="mc-modal__filter-footer">
          <b-col sm="12" md="6" class="mc-modal__filter-footer-fav">
            <div class="button-items"></div>
          </b-col>
          <b-col sm="12" md="6" class="mc-modal__filter-footer-btn">
            <b-button
              variant="outline-primary"
              @click="nextSetup(form)"
              class="me-3"
              :disabled="!form.rfid"
            >
              <i class="mc-fa icon-fill_keypad"></i>
              Konfigurasi lebih lanjut
            </b-button>
            <b-button variant="outline-primary" @click="cancel()" class="me-3">
              <i class="mc-fa icon-outline_close"></i>
              Tutup
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>

    <confirmation v-if="modalConfirm" :modal.sync="modalConfirm" @confirmed="toDelete" />
  </Layout>
</template>
